/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { getRandomId } from './getRandomId';

export const getDummyArray = ({ length, prefix }: { length: number; prefix?: string }): string[] => {
  if (length < 1) {
    return [];
  }
  const result: string[] = [];
  for (let i = 0; i < length; i++) {
    result.push(getRandomId(prefix));
  }
  return result;
};
